import React, { Component } from "react";
import {Link} from 'react-router-dom';
import Hero from '../components/Hero';
import SingleProductImg from '../images/singleProduct.jpg';
import {ProductConsumer} from '../context';
import PizzaSizeChoice from "../components/PizzaSizeChoice";
import BurgerSizeChoice from "../components/BurgerSizeChoice";
import ExtraToppingChoice from "../components/ExtraToppingChoice";
import DressingOnPizza from "../components/DressingOnPizza";


export default class SingleProductPage extends Component {
	render() {
		return (
			<>
			<Hero img={SingleProductImg} />
			<ProductConsumer >
{value=>{
	const{shopOpenTime,singleProduct,addToCart,loading,productprice,price,price1,price2}=value;
	const isOpen = shopOpenTime();
	let bestil
	if (isOpen){
		bestil = <Link to= '/products' type='button' className='main-link' style={{margin:'0.75rem'}} onClick={()=>addToCart(singleProduct)}>Tilføj Kurv</Link>}
		else {bestil = <Link to= '/products' type='button' className='main-link' style={{margin:'0.75rem'}}>Bestiles fra Åbningstid</Link>} 
	if(loading){

		return <h1>product loading..</h1>
	}else{
	const{nr,pName,topping,category}=singleProduct

	switch (true) {


		case category.slice(-5) === "PIZZA":
			return <section className='py-5'>
						<div className='contanier'>
							<div className='row'>
								<div className='col-10 mx-auto col-sm8 col-md-6 my-3'>
									<h5 className="text-title mb-4">{nr}. {pName} pris: {productprice}</h5>
									<h5 className="text-capitalize text-muted mb-4">{topping}</h5>
									<h5 className="text-capitalize text-main mb-4">Almindelig: kr {price}</h5>
									<h5 className="text-capitalize text-main mb-4">Deeppan: kr {price1}</h5>
									<h5 className="text-capitalize text-main mb-4">Familie: kr {price2}</h5>
									<PizzaSizeChoice/>
									<ExtraToppingChoice/>
									<DressingOnPizza/>
									{bestil}{/* <Link to= '/products' type='button' className='main-link' style={{margin:'0.75rem'}} onClick={()=>addToCart(singleProduct)}>Tilføj Kurv</Link> */}
									<Link to='/products' className='main-link' style={{margin:'0.75rem'}}>Tilbage til Produkter</Link>	
								</div>
							</div>
						</div>
					</section>
			
		// case category === "Burgers":
		// 	return <section className='py-5'>
		// 				<div className='contanier'>
		// 					<div className='row'>
							
		// 						<div className='col-10 mx-auto col-sm8 col-md-6 my-3'>
		// 							<h5 className="text-title mb-4">{nr}. {pName} pris: {productprice}</h5>
		// 							<h5 className="text-capitalize text-main mb-4">Almindelig: kr {price}</h5>
		// 							<h5 className="text-capitalize text-main mb-4">Hjemmelavet: kr {price1}</h5>
		// 							<BurgerSizeChoice/>
		// 							<button type='button' className='main-link' style={{margin:'0.75rem'}} onClick={()=>addToCart(singleProduct)}>Tilføj Kurv</button>
		// 							<Link to='/products' className='main-link' style={{margin:'0.75rem'}}>Tilbage til Produkter</Link>	
		// 						</div>
		// 					</div>
		// 				</div>
		// 			</section>
		// case category === "Pasta":
		// 	return <section className='py-5'>
		// 				<div className='contanier'>
		// 					<div className='row'>
		// 						<div className='col-10 mx-auto col-sm8 col-md-6 my-3'>
		// 							<h5 className="text-title mb-4">{nr}. {pName} pris: {productprice}</h5>
		// 							<h5 className="text-capitalize text-muted mb-4">{topping}</h5>
		// 							<h5 className="text-capitalize text-main mb-4">Portion: kr {price}</h5>
		// 							<button type='button' className='main-link' style={{margin:'0.75rem'}} onClick={()=>addToCart(singleProduct)}>Tilføj Kurv</button>
		// 							<Link to='/products' className='main-link' style={{margin:'0.75rem'}}>Tilbage til Produkter</Link>	
		// 						</div>
		// 					</div>
		// 				</div>
		// 			</section>
		default:
			return <section className='py-5'>
			<div className='contanier'>
				<div className='row'>
					<div className='col-10 mx-auto col-sm8 col-md-6 my-3'>
						<h5 className="text-title mb-4">{nr}. {pName} pris: {productprice}</h5>
						<h5 className="text-capitalize text-muted mb-4">{topping}</h5>
						<h5 className="text-capitalize text-main mb-4">Portion: kr {price}</h5>
						{bestil}{/* <button type='button' className='main-link' style={{margin:'0.75rem'}} onClick={()=>addToCart(singleProduct)}>Tilføj Kurv</button> */}
						<Link to='/products' className='main-link' style={{margin:'0.75rem'}}>Tilbage til Produkter</Link>	
					</div>
				</div>
			</div>
		</section>
	}
	
	}
}}

			</ProductConsumer>
			</>
		);
	}
}
